import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-72a0a6da"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "select-competitors"
}, "Select Competitors", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "select-competitors-detail"
}, " From the search results, choose the competitors that closely align with your product. ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_b_img = _resolveComponent("b-img");
  const _component_TextValue = _resolveComponent("TextValue");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_AppRating = _resolveComponent("AppRating");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  return _openBlock(), _createElementBlock("div", null, [_hoisted_1, _hoisted_2, _createVNode(_component_b_table_lite, {
    class: "lite-table competitors-table",
    fields: $data.tableFields,
    items: $props.competitors,
    responsive: "",
    bordered: "",
    fixed: "",
    "sticky-header": "",
    striped: "",
    onRowClicked: $options.onRowSelect
  }, {
    "head(select)": _withCtx(() => [_createVNode(_component_hug_value, {
      styles: {
        padding: 0
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_b_form_checkbox, {
        modelValue: $data.selectall,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.selectall = $event),
        onChange: $options.selectAll
      }, null, 8, ["modelValue", "onChange"])]),
      _: 1
    })]),
    "cell(select)": _withCtx(row => [_createVNode(_component_hug_value, {
      styles: $data.styles.standardWrap
    }, {
      default: _withCtx(() => [_createVNode(_component_b_form_checkbox, {
        modelValue: row.item.isSelected,
        "onUpdate:modelValue": $event => row.item.isSelected = $event,
        disabled: $options.selectedCompetitors.length >= $data.selectLimit && !row.item.isSelected
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
      _: 2
    }, 1032, ["styles"])]),
    "cell(title)": _withCtx(row => [_createVNode(_component_hug_value, null, {
      default: _withCtx(() => [_createVNode(_component_flex_row, {
        gap: 8,
        styles: {
          justifyContent: 'flex-start'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_b_img, {
          src: row.item.image,
          alt: "Image",
          width: 28,
          height: 28,
          style: {
            borderRadius: '4px',
            backgroundColor: '#ffffff'
          }
        }, null, 8, ["src"]), _createVNode(_component_TextValue, {
          value: row.item.title,
          styles: {
            width: 'calc(302px - 42px)',
            fontSize: '14px'
          }
        }, null, 8, ["value", "styles"])]),
        _: 2
      }, 1024)]),
      _: 2
    }, 1024)]),
    "cell(asin)": _withCtx(row => [_createVNode(_component_hug_value, {
      styles: $data.styles.standardWrap
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(row.item.asin), 1)]),
      _: 2
    }, 1032, ["styles"])]),
    "cell(rating)": _withCtx(row => [_createVNode(_component_hug_value, {
      styles: $data.styles.standardWrap
    }, {
      default: _withCtx(() => [_createVNode(_component_AppRating, {
        rating: row.item.rating,
        count: row.item.votes,
        size: 16
      }, null, 8, ["rating", "count"])]),
      _: 2
    }, 1032, ["styles"])]),
    _: 1
  }, 8, ["fields", "items", "onRowClicked"])]);
}